import resolveResponsiveValue from '../../resolvers/ResponsiveValueResolver';
export default function resolveFlex(theme, screenWidth, flexSupport) {
    var result = {
        display: 'flex',
    };
    var horizontal = resolveResponsiveValue(theme, screenWidth, flexSupport.horizontal);
    var wrap = resolveResponsiveValue(theme, screenWidth, flexSupport.wrap);
    var stretch = resolveResponsiveValue(theme, screenWidth, flexSupport.stretch);
    var vStart = resolveResponsiveValue(theme, screenWidth, flexSupport.vStart);
    var vCenter = resolveResponsiveValue(theme, screenWidth, flexSupport.vCenter);
    var vEnd = resolveResponsiveValue(theme, screenWidth, flexSupport.vEnd);
    var hStart = resolveResponsiveValue(theme, screenWidth, flexSupport.hStart);
    var hCenter = resolveResponsiveValue(theme, screenWidth, flexSupport.hCenter);
    var hEnd = resolveResponsiveValue(theme, screenWidth, flexSupport.hEnd);
    var spaceBetween = resolveResponsiveValue(theme, screenWidth, flexSupport.spaceBetween);
    var spaceAround = resolveResponsiveValue(theme, screenWidth, flexSupport.spaceAround);
    result.flexDirection = horizontal ? 'row' : 'column';
    result.flexWrap = wrap ? 'wrap' : 'nowrap';
    result.flexBasis = resolveResponsiveValue(theme, screenWidth, flexSupport.flexBasis);
    if (stretch) {
        result.flex = 1;
    }
    result.alignItems =
        // Align items is vertical center for horizontal or horizontal center for vertical
        (horizontal && vCenter) || (!horizontal && hCenter)
            ? 'center'
            : (horizontal && vStart) || (!horizontal && hStart)
                ? 'flex-start'
                : (horizontal && vEnd) || (!horizontal && hEnd)
                    ? 'flex-end'
                    : 'stretch'; // is the default value
    result.justifyContent =
        spaceAround ? 'space-around' :
            // Justify content is horizontal center for horizontal or vertical center for horizontal
            // also space-between is possible
            spaceBetween
                ? 'space-between;'
                : (horizontal && hCenter) || (!horizontal && vCenter)
                    ? 'center'
                    : (horizontal && hEnd) || (!horizontal && vEnd)
                        ? 'flex-end'
                        : 'flex-start'; // is the default value
    return result;
}
//# sourceMappingURL=FlexResolver.js.map